<template>
  <div class="ticket-table-card">
    <div class="table-title">{{ticketTableTitle}}</div>
    <el-table :data="tableData"
              style="width: 100%"
              max-height="300">
      <!-- 序号 -->
      <el-table-column width="100"
                       type="index"
                       :label="this.$t('alarmHistory.index')">
      </el-table-column>
      <!-- 产品名称 -->
      <el-table-column prop="productName"
                       :label="this.$t('cabinetReservation.productName')">
      </el-table-column>
      <!-- 预留数量 -->
      <el-table-column prop="quantity"
                       :label="this.$t('cabinetReservation.applyNum')">
        <template slot-scope="scope">
          <span>{{scope.row.quantity | maybeEmpty}}</span>
        </template>
      </el-table-column>
      <!-- 单位 -->
      <el-table-column prop="cabinetSpaceName"
                       :label="this.$t('cabinetReservation.unit')">
        <template slot-scope="scope">
          <span>{{$t('cabinetReservation.one')}}</span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import cloneDeep from 'lodash';

export default {
  props: {
    tableData: {
      type: Array,
      default () { return null; },
    },
    ticketTableTitle: {
      type: String,
      default: ''
    }
  },
  computed: {
    ticketInfoTableCopy () {
      return cloneDeep(this.ticketInfo);
    }
  }
};
</script>
<style lang="scss" scoped>
.table-title {
  height: 40px;
  line-height: 40px;
  background-color: #f3f7fb;
  border: 1px solid #d9e1e9;
  font-size: 13px;
  border-bottom: none;
  padding-left: 8px;
}
.ticket-table-card {
  margin: 10px 0 20px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/workSheet/cabinet-reservation/opt/ShowCabinetsDetail.vue